import React from 'react';
import { companyInfo } from '../data/mock';

const AboutSection = () => {
  return (
    <section id="about" className="bg-black py-24 md:py-32 px-[7.6923%]">
      <div className="max-w-[1400px] mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-semibold text-white mb-4 tracking-tight">
            About {companyInfo.name}
          </h2>
          <div className="w-20 h-1 bg-[#00FFD1] mx-auto"></div>
        </div>

        <div className="max-w-[1000px] mx-auto">
          <p className="text-lg md:text-xl text-white/85 leading-relaxed mb-6">
            {companyInfo.description}
          </p>

          {/* LYNQ and NEXT descriptions - Enhanced Design */}
          <div className="grid md:grid-cols-2 gap-8 my-16">
            {/* LYNQ Box */}
            <div className="relative bg-gradient-to-br from-[#121212] to-[#0a0a0a] p-8 border-2 border-[#00FFD1]/30 overflow-hidden group hover:border-[#00FFD1] transition-all duration-500">
              {/* Decorative corner accent */}
              <div className="absolute top-0 left-0 w-20 h-20 bg-[#00FFD1]/10"></div>
              <div className="absolute bottom-0 right-0 w-16 h-16 bg-[#00FFD1]/5"></div>
              
              {/* Content */}
              <div className="relative z-10">
                <div className="flex items-center gap-3 mb-4">
                  <div className="text-4xl font-bold text-[#00FFD1]">LYNQ</div>
                  <div className="flex-1 h-px bg-gradient-to-r from-[#00FFD1] to-transparent"></div>
                </div>
                <p className="text-lg text-white/90 leading-relaxed font-light">
                  Our foundation. Where we audit the chaos and find the signals that matter.
                </p>
                <div className="mt-4 pt-4 border-t border-white/10">
                  <p className="text-sm text-[#00FFD1]/80 font-medium tracking-wide uppercase">
                    Proprietary Friction Diagnostic
                  </p>
                </div>
              </div>
              
              {/* Hover glow effect */}
              <div className="absolute inset-0 bg-gradient-to-br from-[#00FFD1]/0 via-[#00FFD1]/0 to-[#00FFD1]/5 opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
            </div>

            {/* NEXT Box */}
            <div className="relative bg-gradient-to-br from-[#121212] to-[#0a0a0a] p-8 border-2 border-[#00FFD1]/30 overflow-hidden group hover:border-[#00FFD1] transition-all duration-500">
              {/* Decorative corner accent */}
              <div className="absolute top-0 right-0 w-20 h-20 bg-[#00FFD1]/10"></div>
              <div className="absolute bottom-0 left-0 w-16 h-16 bg-[#00FFD1]/5"></div>
              
              {/* Content */}
              <div className="relative z-10">
                <div className="flex items-center gap-3 mb-4">
                  <div className="text-4xl font-bold text-[#00FFD1]">NEXT</div>
                  <div className="flex-1 h-px bg-gradient-to-r from-[#00FFD1] to-transparent"></div>
                </div>
                <p className="text-lg text-white/90 leading-relaxed font-light">
                  Our promise. The predictive, profitable leap into the future.
                </p>
                <div className="mt-4 pt-4 border-t border-white/10">
                  <p className="text-sm text-[#00FFD1]/80 font-medium tracking-wide uppercase">
                    Building the Magnet
                  </p>
                </div>
              </div>
              
              {/* Hover glow effect */}
              <div className="absolute inset-0 bg-gradient-to-br from-[#00FFD1]/0 via-[#00FFD1]/0 to-[#00FFD1]/5 opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
            </div>
          </div>

          <p className="text-lg md:text-xl text-white/85 leading-relaxed mb-8">
            {companyInfo.closingStatement}
          </p>

          {/* Key Services */}
          <div className="grid md:grid-cols-3 gap-8 mt-16">
            <div className="bg-[#121212] p-8 border border-white/25 transition-all duration-400 hover:border-[#00FFD1] hover:shadow-[0_0_20px_rgba(0,255,209,0.2)]">
              <h3 className="text-2xl font-semibold text-white mb-4">Advisory</h3>
              <p className="text-base text-white/85 leading-relaxed">
                Strategic guidance for digital transformation and mar-tech adoption. Partnering leadership teams to create growth blueprint.
              </p>
            </div>

            <div className="bg-[#121212] p-8 border border-white/25 transition-all duration-400 hover:border-[#00FFD1] hover:shadow-[0_0_20px_rgba(0,255,209,0.2)]">
              <h3 className="text-2xl font-semibold text-white mb-4">Execution</h3>
              <p className="text-base text-white/85 leading-relaxed">
                End-to-end implementation support ensuring seamless deployment and adoption.
              </p>
            </div>

            <div className="bg-[#121212] p-8 border border-white/25 transition-all duration-400 hover:border-[#00FFD1] hover:shadow-[0_0_20px_rgba(0,255,209,0.2)]">
              <h3 className="text-2xl font-semibold text-white mb-4">Partner Selection</h3>
              <p className="text-base text-white/85 leading-relaxed">
                Expert evaluation and matchmaking with the right technology partners for your business.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
